exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../css-loader/index.js!./style.css"), "");
exports.i(require("-!../../css-loader/index.js!./animated.css"), "");

// module
exports.push([module.id, ".yc-icon {\n    display: inline-block;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/@ycgame/icons/yc-icons.css
// module id = 25
// module chunks = 1